import { ProviderBuilder, EGenMode } from '@educraft/base';
import { QR } from './generators/QR';
import { PisemkaTest } from './generators/PisemkaTest';
import {
  Kolickovani__1,
  Kolickovani__2,
  Kolickovani__Side,
  Kolickovani__Corners,
  Kolickovani__Circles,
  Kolickovani__Flowers,
  Kolickovani__Wheel,
  Kolickovani__Rainbow,
  Kolickovani__BW,
} from './generators/Kolickovani';
import { MiniLUK } from './generators/MiniLUK';
import { TestSheet } from './generators/TestSheet';
import { LCD_Tabulka__3, LCD_Tabulka__5 } from './generators/LCD_Tabulka';
import {
  Piccolo_Multi__Mini,
  Piccolo_Multi__Base,
  Piccolo_Multi__ZigZag1,
  Piccolo_Multi__ZigZag2,
  Piccolo_Multi__PaperA5,
  Piccolo_Multi__Diagonal,
  Primo_Multi__Base,
  Primo_Multi__ZigZag1,
  Primo_Multi__ZigZag2,
  Primo_Multi__Mini,
  Primo_Multi__Diagonal,
  Maximo_Multi__Base,
  Maximo_Multi__ZigZag1,
  Maximo_Multi__ZigZag2,
  Maximo_Multi__Mini,
  Maximo_Multi__Diagonal,
} from './generators/Logico';
import {
  Dlazdice__Srdce,
  Dlazdice__Dum,
  Dlazdice__Smajlik,
  Dlazdice__T,
  Dlazdice__Zamek,
  Dlazdice__Krouzek,
  Dlazdice__Lilie,
  Dlazdice__Mec,
  Dlazdice__Kafe,
  Dlazdice__Vrtulnik,
} from './generators/Dlazdice';
import {
  QR_Hra__Check as MultiQR_Hra__Check,
  QR_Hra__Quiz as MultiQR_Hra__Quiz,
  QR_Hra__Task as MultiQR_Hra__Task,
} from './generators/QR_Hra';

export function registerLayoutMulti(builder: ProviderBuilder) {
  builder.add(EGenMode.LayoutMulti, QR, 'Multi.QR');
  builder.add(EGenMode.LayoutMulti, PisemkaTest, 'Multi.PisemkaTest');
  builder.add(EGenMode.LayoutMulti, Kolickovani__1, 'Multi.Kolickovani__1');
  builder.add(EGenMode.LayoutMulti, Kolickovani__2, 'Multi.Kolickovani__2');
  builder.add(EGenMode.LayoutMulti, Kolickovani__Side, 'Multi.Kolickovani__Side');
  builder.add(EGenMode.LayoutMulti, Kolickovani__Corners, 'Multi.Kolickovani__Corners');
  builder.add(EGenMode.LayoutMulti, Kolickovani__Circles, 'Multi.Kolickovani__Circles');
  builder.add(EGenMode.LayoutMulti, Kolickovani__Flowers, 'Multi.Kolickovani__Flowers');
  builder.add(EGenMode.LayoutMulti, Kolickovani__Wheel, 'Multi.Kolickovani__Wheel');
  builder.add(EGenMode.LayoutMulti, Kolickovani__Rainbow, 'Multi.Kolickovani__Rainbow');
  builder.add(EGenMode.LayoutMulti, Kolickovani__BW, 'Multi.Kolickovani__BW');
  builder.add(EGenMode.LayoutMulti, MiniLUK, 'Multi.MiniLUK');

  // Piccolo Multi variants
  builder.add(EGenMode.LayoutMulti, Piccolo_Multi__Base, 'Multi.Piccolo__Base');
  builder.add(EGenMode.LayoutMulti, Piccolo_Multi__ZigZag1, 'Multi.Piccolo__ZigZag1');
  builder.add(EGenMode.LayoutMulti, Piccolo_Multi__ZigZag2, 'Multi.Piccolo__ZigZag2');
  builder.add(EGenMode.LayoutMulti, Piccolo_Multi__Mini, 'Multi.Piccolo__Mini');
  builder.add(EGenMode.LayoutMulti, Piccolo_Multi__PaperA5, 'Multi.Piccolo__PaperA5');
  builder.add(EGenMode.LayoutMulti, Piccolo_Multi__Diagonal, 'Multi.Piccolo__Diagonal');

  // Primo Multi variants
  builder.add(EGenMode.LayoutMulti, Primo_Multi__Base, 'Multi.Primo__Base');
  builder.add(EGenMode.LayoutMulti, Primo_Multi__ZigZag1, 'Multi.Primo__ZigZag1');
  builder.add(EGenMode.LayoutMulti, Primo_Multi__ZigZag2, 'Multi.Primo__ZigZag2');
  builder.add(EGenMode.LayoutMulti, Primo_Multi__Mini, 'Multi.Primo__Mini');
  builder.add(EGenMode.LayoutMulti, Primo_Multi__Diagonal, 'Multi.Primo__Diagonal');

  // Maximo Multi variants
  builder.add(EGenMode.LayoutMulti, Maximo_Multi__Base, 'Multi.Maximo__Base');
  builder.add(EGenMode.LayoutMulti, Maximo_Multi__ZigZag1, 'Multi.Maximo__ZigZag1');
  builder.add(EGenMode.LayoutMulti, Maximo_Multi__ZigZag2, 'Multi.Maximo__ZigZag2');
  builder.add(EGenMode.LayoutMulti, Maximo_Multi__Mini, 'Multi.Maximo__Mini');
  builder.add(EGenMode.LayoutMulti, Maximo_Multi__Diagonal, 'Multi.Maximo__Diagonal');

  // Tiles (Dlazdice)
  builder.add(EGenMode.LayoutMulti, Dlazdice__Srdce, 'Multi.Dlazdice__Srdce');
  builder.add(EGenMode.LayoutMulti, Dlazdice__Dum, 'Multi.Dlazdice__Dum');
  builder.add(EGenMode.LayoutMulti, Dlazdice__Smajlik, 'Multi.Dlazdice__Smajlik');
  builder.add(EGenMode.LayoutMulti, Dlazdice__T, 'Multi.Dlazdice__T');
  builder.add(EGenMode.LayoutMulti, Dlazdice__Zamek, 'Multi.Dlazdice__Zamek');
  builder.add(EGenMode.LayoutMulti, Dlazdice__Krouzek, 'Multi.Dlazdice__Krouzek');
  builder.add(EGenMode.LayoutMulti, Dlazdice__Lilie, 'Multi.Dlazdice__Lilie');
  builder.add(EGenMode.LayoutMulti, Dlazdice__Mec, 'Multi.Dlazdice__Mec');
  builder.add(EGenMode.LayoutMulti, Dlazdice__Kafe, 'Multi.Dlazdice__Kafe');
  builder.add(EGenMode.LayoutMulti, Dlazdice__Vrtulnik, 'Multi.Dlazdice__Vrtulnik');

  builder.add(EGenMode.LayoutMulti, MultiQR_Hra__Check, 'Multi.QR_Hra__Check');
  builder.add(EGenMode.LayoutMulti, MultiQR_Hra__Quiz, 'Multi.QR_Hra__Quiz');
  builder.add(EGenMode.LayoutMulti, MultiQR_Hra__Task, 'Multi.QR_Hra__Task');

  builder.add(EGenMode.LayoutMulti, TestSheet, 'Multi.TestSheet');

  builder.add(EGenMode.LayoutMulti, LCD_Tabulka__3, 'Multi.LCD_Tabulka__3');
  builder.add(EGenMode.LayoutMulti, LCD_Tabulka__5, 'Multi.LCD_Tabulka__5');
}
